var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMediaTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6146 4.88925C15.5153 4.88925 13.8074 3.18134 13.8074 1.08203C13.8074 0.758392 13.5451 0.496094 13.2215 0.496094H10.0833C9.75986 0.496094 9.49741 0.758392 9.49741 1.08203V13.9479C9.49741 15.1821 8.49323 16.1861 7.25909 16.1861C6.02496 16.1861 5.02094 15.1821 5.02094 13.9479C5.02094 12.7137 6.02496 11.7096 7.25909 11.7096C7.58273 11.7096 7.84503 11.4473 7.84503 11.1237V7.98557C7.84503 7.66208 7.58273 7.39963 7.25909 7.39963C3.64841 7.39963 0.710938 10.3372 0.710938 13.9479C0.710938 17.5586 3.64841 20.4961 7.25909 20.4961C10.8698 20.4961 13.8074 17.5586 13.8074 13.9479V8.2529C14.9735 8.87469 16.2712 9.19925 17.6146 9.19925C17.9383 9.19925 18.2006 8.93695 18.2006 8.61331V5.47519C18.2006 5.1517 17.9383 4.88925 17.6146 4.88925Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaTiktokIcon);
export default __webpack_public_path__ + "static/media/social-media-tiktok-icon.d6d9fd68a98e00a3d9fe9b809ba26656.svg";
export { ForwardRef as ReactComponent };